import { isEqual } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const deepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
